module.exports = __webpack_public_path__ + "static/media/mongo.b4cda8a5.png";